export const dataTestKeys = ['data-test-component', 'data-test-id'];
export const buildDataTestProps = _ref => {
  let {
    dataTestComponent,
    dataTestId
  } = _ref;
  const testComponentProp = !!dataTestComponent ? {
    'data-test-component': dataTestComponent
  } : {};
  const testIdProp = !!dataTestId ? {
    'data-test-id': dataTestId
  } : {};
  return {
    ...testComponentProp,
    ...testIdProp
  };
};